import { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { Fade } from "@mui/material";
import ModalAgendarContato from "./abaAgendamentos/ModalAgendarContato";
import { useAgendamentoContatoContext } from "context/gestaoCobranca/AgendamentoContatoContext";
import TabelaAgendamentosContatos from "./abaAgendamentos/TabelaAgendamentosContatos";
import { BoxInformativosAgendamento } from "./abaAgendamentos/BoxInformativosAgendamento";
import FiltrosAgendamentosContatos from "./abaAgendamentos/FiltrosAgendamentosContatos";

export const TabAgendamentos = () => {
  const [mostrarConteudo, setMostrarConteudo] = useState<boolean>(false);
  const {
    showModalAgendamentoContato,
    openCloseModalAgendamentoContato,
    setDataAgendamento,
    setTipoStatusAgendamento,
    setUnidadeSacadoQuery,
    setCondominioId,
  } = useAgendamentoContatoContext();

  useEffect(() => {
    setMostrarConteudo(true);
    return () => {
      setDataAgendamento(null);
      setTipoStatusAgendamento(null);
      setUnidadeSacadoQuery("");
      setCondominioId(null);
    };
  }, []);

  return (
    <Container>
      <Fade in={mostrarConteudo} timeout={700}>
        <div>
          <BoxInformativosAgendamento />
          <FiltrosAgendamentosContatos />
          <Row>
            <TabelaAgendamentosContatos />
          </Row>
          <ModalAgendarContato
            showModal={showModalAgendamentoContato}
            onCloseModal={() => {
              openCloseModalAgendamentoContato();
            }}
          />
        </div>
      </Fade>
    </Container>
  );
};
